<template>
<div>
    <div class="token-sales card mrnr">
        <div class="card-innr">
            <div class="token-rate-wrap row">
                <div class="token-rate col-md-6 col-lg-12">
                    <router-link tag="a" :to="{name: 'index'}" class="text-dark">
                        Главная
                    </router-link>
                </div>
            </div>
            <div class="token-rate-wrap row">
                <div class="token-rate col-md-6 col-lg-12">
                    <router-link tag="a" :to="{name: 'bonus'}" class="text-dark">
                        Бонусы
                    </router-link>
                </div>
            </div>
            <div class="token-rate-wrap row">
                <div class="token-rate col-md-6 col-lg-12">
                    <router-link tag="a" :to="{name: 'settings'}" class="text-dark">
                        Настройки аккаунта
                    </router-link>
                </div>
            </div>
            <div class="token-rate-wrap row">
                <div class="token-rate col-md-6 col-lg-12">
                    <router-link tag="a" :to="{name: 'revshare'}" class="text-dark">
                        Мои рефералы
                    </router-link>
                </div>
            </div>
            <div class="token-rate-wrap row">
                <div class="token-rate col-md-6 col-lg-12">
                    <router-link tag="a" :to="{name: 'contacts'}" class="text-dark">
                        Контакты
                    </router-link>
                </div>
            </div>
            <hr v-if="$root.user !== null && $root.user.is_admin">
            
            <div class="token-rate-wrap row" v-if="$root.user !== null && $root.user.is_admin">
                <div class="token-rate col-md-6 col-lg-12">
                    <a href="/admin" target="_blank" class="text-dark">
                        ПУ
                    </a>
                </div>
            </div>

            <!-- <div class="token-rate-wrap row">
                <div class="token-rate col-md-6 col-lg-12">
                    <div class="text-dark" style="cursor:pointer" @click="$root.logout">Выход</div>
                </div>
            </div> -->
        </div>
    </div>
</div>
</template>

<script>
    export default {
        props: ['page'],
    }
</script>